import { Component, computed, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { PROFILES } from "../../../../assets/profiles/profiles";
import { SessionDataService } from "../../../services/shared/SessionDataService.service";

/** Status indicators for data restrictions, suspicions, and data protection, visible only to the active ARSON profile. */
@Component({
  selector: "app-arson-option-status",
  imports: [TranslateModule],
  templateUrl: "./arson-option-status.component.html",
  styleUrls: ["./arson-option-status.component.scss"]
})
export class ArsonOptionStatusComponent {
  readonly session = inject(SessionDataService);
  readonly visible = computed(() => this.session.profile() === PROFILES.ARSON);
}
